<!-- CONTAINER -->
<div class="container content-area relative">
    <!-- PAGE-HEADER -->
    <div class="page-header">
        <h4 class="page-title">Astrologer Payout</h4>
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/admin/dashboard']">Home</a></li>
            <li class="breadcrumb-item"><a [routerLink]="['/admin/astrologersList']">Astrologer</a></li>
            <li class="breadcrumb-item active" aria-current="page">Payout</li>
        </ol>
    </div>
    <!-- PAGE-HEADER END -->
    
    <!-- ROW-1 OPEN -->
    <div class="row" id="user-profile">
        <div class="col-lg-12">
            <div class="card">
                <div class="border-top">
                    <div class="wideget-user-tab">
                        <div class="tab-menu-heading">
                            <div class="tabs-menu1">
                                <ul class="nav-tabs nav mb-4">
                                    <li class="nav-item">
                                        <a [routerLink]="['/admin/payout/history']" class="nav-link"
                                            routerLinkActive="active">Payout History</a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="['/admin/payout/wallet']" class="nav-link"
                                            routerLinkActive="active">Wallet</a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="['/admin/payout/orders']" class="nav-link"
                                            routerLinkActive="active">Orders</a>
                                    </li>
                                    <li class="nav-item">
                                        <a [routerLink]="['/admin/payout/release']" class="nav-link"
                                            routerLinkActive="active">Last Month Payout</a>
                                    </li>
                                </ul>
                                <router-outlet></router-outlet>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- COL-END -->
    </div>
    <!-- ROW-1 CLOSED -->
</div>
<!-- CONTAINER CLOSED -->
